<template>
  <el-container>
    <el-header>
      <el-tabs class="mt-3" v-model="type" @tab-click="handleTabClick" type="card">
        <el-tab-pane  :label="$t('密码管理')" name="password"></el-tab-pane>
        <el-tab-pane  :label="$t('组管理')" name="group"></el-tab-pane>
      </el-tabs>
    </el-header>
    <el-main>
      <div>
        <div class="action-bar">
          <el-button type="primary" size="medium" @click="handleAdd">{{ $t('添加密码项') }}</el-button>
        </div>
        <template>
          <el-form inline ref="form" :model="searchFrom" label-width="100px">
            <el-form-item :label="$t('我加入的组')">
              <el-select v-model="searchFrom.group_id" clearable placeholder="请选择"
                         @change="handleGroupChange"
                         @clear="handleGroupClear"
                         size="small"
              >
                <el-option
                    v-for="item in groupList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('密码名称')" class="mb-0">
              <el-input  size="small" v-model="searchFrom.name"  @input="searchEvent"></el-input>
            </el-form-item>
            <el-form-item class="mb-0">
              <el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
              <el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
            </el-form-item>
          </el-form>
        </template>

        <el-table
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
        >
          <el-table-column fixed prop="id" label="ID" width="50"></el-table-column>
          <el-table-column prop="name" label="名称" width="120"></el-table-column>
          <el-table-column prop="username" label="用户名" width="120">
            <template v-slot="scope">
              <el-link
                  type="primary"
                  @click="copyUsername(scope.row.username)"
              >
                {{ scope.row.username }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="密码" min-width="200">
            <template  v-slot="scope">
              <span v-if = "scope.row.password">
                              <el-link type="primary"
                                       v-if="!scope.row.showPassword"
                                       @click="copyPassword(scope.row.password)"
                              >••••••</el-link>
              <el-link
                  v-else
                  @click="copyPassword(scope.row.password)"
              >{{ scope.row.password }}</el-link>
              <el-button
                  type="text"
                  size="mini"
                  @click="togglePassword(scope.row)"
              >
                {{ scope.row.showPassword ? '隐藏' : '显示' }}
              </el-button>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="URL" min-width="300">
            <template v-slot="scope">
              <el-link
                  type="primary"
                  :href="scope.row.url"
                  target="_blank"
                  :underline="false"
              >
                {{ scope.row.url }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="图片" min-width="150">
            <template v-slot="scope">
              <el-button v-if="scope.row.image" type="text" size="small" @click = "showImage(scope.row.image)">显示图片</el-button>

            </template>
          </el-table-column>
          <el-table-column label="密钥下载" min-width="150">
            <template v-slot="scope">
              <el-button
                  v-if="scope.row.key"
                  type="text"
                  size="small"
                  @click="downloadKey(scope.row.key)">
                下载密钥
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="description" min-width="200">
            <template v-slot="scope">
              <el-popover
                  v-if="scope.row.description"
                  placement="top-start"
                  title="备注"
                  width="200"
                  trigger="hover"
                  :content="scope.row.description">
                <el-button slot="reference" type="text" size="small">查看备注</el-button>
              </el-popover>
            </template>

          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="150">
            <template v-slot="scope" >
                <el-button
                    v-if="scope.row.access_level === 'admin' || scope.row.access_level === 'write'"
                    type="text" size="small" @click="handleEdit(scope.row)">
                  编辑
                </el-button>
                <el-button
                    v-if="scope.row.access_level === 'admin' || scope.row.access_level === 'write'"
                    type="text" size="small" class="delete-btn" @click="handleDelete(scope.row)">
                  {{ $t('删除') }}
                </el-button>
              <el-button
                  v-if="scope.row.access_level === 'admin'"
                  type="text" size="small" class="delete-btn"
                  @click = "setCurrentSharingItem(scope.row)"
              >
                {{ $t('分享') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total">
          </el-pagination>
        </div>
        <!-- 表单对话框 -->
        <el-dialog
            :title="dialogType === 'add' ? $t('添加密码项') : `${$t('修改密码项')} - ${passwordFrom.name || ''}`"
            :visible.sync="dialogVisible"
            width="500px"
            append-to-body
            @close="resetForm">
          <el-form :model="passwordFrom" :rules="formRules" ref="trafficForm" label-width="100px">
            <el-form-item :label="$t('名称')" prop="name">
              <el-input v-model="passwordFrom.name" placeholder="请输入密码名称"></el-input>
            </el-form-item>
            <el-form-item :label="$t('用户名')" prop="username">
              <el-input v-model="passwordFrom.username" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item :label="$t('密码')" prop="password">
              <el-input v-model="passwordFrom.password" type="password" :show-password="true" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item :label="$t('URL')" prop="url">
              <el-input v-model="passwordFrom.url" placeholder="请输入URL"></el-input>
            </el-form-item>
            <el-form-item :label="$t('备注')" prop="description">
                <el-input
                    maxlength="100"
                    type="textarea"
                    autosize
                    :show-word-limit = "true"
                    placeholder="请输入内容"
                    v-model="passwordFrom.description">
                </el-input>
            </el-form-item>
            <el-form-item :label="$t('密钥文件')" prop="image">
              <el-upload
                  :show-file-list="true"
                  :http-request="handleKeyUpload"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="keyFileList"
                  :on-remove="handleKeyRemove"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <!--              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
              </el-upload>
            </el-form-item>
            <el-form-item :label="$t('图片')" prop="image">
              <el-upload
                  :show-file-list="true"
                  :http-request="handleUpload"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="imageFileList"
                  :on-remove="handleImageRemove"
              >
              <el-button size="small" type="primary">点击上传</el-button>
<!--              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
              </el-upload>
              <el-image v-if="passwordFrom.image" :src="passwordFrom.image" class="avatar" style="max-width: 100px; max-height: 100px; margin-top: 10px;">
              </el-image>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="submitForm">确认</el-button>
          </span>
        </el-dialog>
        <el-dialog
            :title="$t('图片内容')"
            :visible.sync="dialogImageVisible"
            width="500px"
            append-to-body
            @close="closeImageDialog">
          <el-image
              :src="imageUrl">
          </el-image>

        </el-dialog>
        <!-- 在template中添加分享对话框 -->
        <el-dialog
            title="分享密码项"
            :visible.sync="dialogShareVisible"
            width="600px"
            append-to-body
            @close="resetShareForm">
          <el-form :model="shareForm" label-width="80px">
            <!-- 新增：目标类型单选框 -->
            <el-form-item label="分享类型">
              <el-radio-group v-model="shareForm.targetType" @change="handleTargetTypeChange">
                <el-radio label="user">用户</el-radio>
                <el-radio label="group">组</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 动态切换的选择器 -->
            <el-form-item label="分享给">
              <!-- 用户选择模式 -->
              <el-select
                  v-if="shareForm.targetType === 'user'"
                  v-model="shareForm.userTargets"
                  multiple
                  filterable
                  remote
                  reserve-keyword
                  placeholder="输入用户名搜索"
                  :remote-method="searchUsers"
                  :loading="loading"
                  class="share-target-select">
                <el-option
                    v-for="user in userOptions"
                    :key="user.id"
                    :label="user.name"
                    :value="user.id">
                </el-option>
              </el-select>

              <!-- 组选择模式 -->
              <el-select
                  v-else
                  v-model="shareForm.groupTargets"
                  multiple
                  filterable
                  remote
                  reserve-keyword
                  placeholder="输入组名搜索"
                  :remote-method="getUserGroup"
                  :loading="loading"
                  class="share-target-select">
                <el-option
                    v-for="group in groupOptions"
                    :key="group.id"
                    :label="group.name"
                    :value="group.id">
                </el-option>
              </el-select>
            </el-form-item>

            <!-- 权限设置 -->
            <el-form-item label="权限">
              <el-radio-group v-model="shareForm.permission">
                <el-radio label="read">只读</el-radio>
                <el-radio label="write">读写</el-radio>
                <el-radio label="admin">管理</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 已分享列表表格 -->
            <el-form-item label="密码权限表">
              <el-tabs v-model="activeShareTab" @tab-click="fetchSharedList">
                <el-tab-pane label="用户" name="user">
                  <el-table
                      :data="sharedUsers"
                      border
                      style="width: 100%"
                      v-loading="loading">
                    <el-table-column prop="username" label="用户名" min-width="120"></el-table-column>
                    <el-table-column label="权限" min-width="100">
                      <template v-slot="scope">
                        {{ formatPermission(scope.row.access_level) }}
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="120">
                      <template v-slot="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="revokeShare('user', scope.row.user_id,scope.row)"
                            class="delete-btn">
                          撤销
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="组" name="group">
                  <el-table
                      :data="sharedGroups"
                      border
                      style="width: 100%"
                      v-loading="loading">
                    <el-table-column prop="name" label="组名" min-width="120"></el-table-column>
                    <el-table-column label="权限" min-width="100">
                      <template v-slot="scope">
                        {{ formatPermission(scope.row.access_level) }}
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="120">
                      <template v-slot="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="revokeShare('group', scope.row.group_id,scope.row)"
                            class="delete-btn">
                          撤销
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>


          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogShareVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmShare">确认分享</el-button>
          </span>
        </el-dialog>
      </div>
    </el-main>
  </el-container>

</template>
<script>

  import router from "@/router";

  export default {
    name: 'password',
    data() {
      return {
        user : JSON.parse(window.sessionStorage.getItem('user')),
        loading: false,
        tableData: [],
        dialogType: 'add',
        dialogVisible: false,
        passwordFrom: {},
        formRules: {
          name : [
            {required: true, message: "请输入密码名称", trigger: 'blur' }
          ]
        },
        searchFrom : {},
        pagination:{
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        groupList : [],
        group_id : '',
        activeMenu : 'workPlace',
        fileList:[],
        dialogImageVisible : false,
        imageUrl : '',
        dialogShareVisible : false,
        currentSharingItem: null,
        shareForm: {
          targetType: 'user', // 'user' 或 'group'
          userTargets: [],    // 选中的用户ID数组
          groupTargets: [],   // 选中的组ID数组
          permission: 'read',
          expiry: null
        },
        userOptions: [],      // 用户搜索结果
        groupOptions: [],
        sharePasswordData:[],
        activeShareTab: 'user', // 当前激活的分享列表标签页
        sharedUsers: [],      // 已分享的用户列表
        sharedGroups: [],     // 已分享的组列表
        currentSharingItemName : '',
        type : 'password',
        keyFileList: [],
        imageFileList: [],
      }
    },
    created() {
      this.getUserGroup()
      this.getUserPasswordList()
    },
    methods: {
      router() {
        return router
      },
      getUserGroup(query){
        this.axios.post('admin/data/userGroupList',{
          search : query
        },{
          token : true
        }).then(res => {
          console.log('gerUserGroup')
          console.log(res.data)
          const {data,status,msg} = res
          if(status === 200 && data && data.data){
            this.groupList = data.data.list
            this.groupOptions = data.data.list
          }else {
            this.$message.error(msg)
          }
        })
      },
      getUserPasswordList() {
        this.loading = true
        const params = {
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          search: this.searchFrom
        }
        this.axios.post('/admin/data/userPasswordList', params, {
          token: true
        }).then(res => {
          const {data, status,msg} = res
          console.log('getUserPasswordList')
          console.log(data)
          if (status === 200 && data && data.data) {
            this.tableData = data.data.list.list
            this.pagination.total = data.data.list.total
          } else {
            this.$message.error(msg)
          }
        }).catch(error => {
          this.$message.error(error)
        }).finally(() => {
          this.loading = false
        })
      },
      getGroupPassword(){
        this.loading = true
        const param = {
          group_id : parseInt(this.group_id),
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          search: this.searchFrom
        }
        this.axios.post('/admin/data/groupPasswordList',param,{
          token : true
        }).then(res => {
          console.log('getGroupPassword')
          console.log(res.data)
          const {status,data,msg} = res
          if(status === 200 && data && data.data){
            this.tableData = data.data.list.list
            this.pagination.total = data.data.list.total
          }else {
            this.$message.error(msg)
          }
        }).catch(error => {
          this.$message.error(error)
        }).finally(() => {
          this.loading = false
        })
      },
      togglePassword(row) {
        // 如果 showPassword 没有定义，就先给它加上
        this.$set(row, 'showPassword', !row.showPassword);
      },
      copyPassword(password) {
        navigator.clipboard.writeText(password).then(() => {
          this.$message.success('密码已复制到剪贴板') // 成功提示
        }).catch(err => {
          console.error('复制失败:', err)
          this.$message.error('复制失败，请手动复制') // 失败提示
        })
      },
      copyUsername(username) {
        navigator.clipboard.writeText(username).then(() => {
          this.$message.success('用户名已复制到剪贴板')
        }).catch(err => {
          console.error('复制失败:', err)
          this.$message.error('复制失败，请手动复制')
        })
      },
      handleEdit(row) {
        this.dialogType = 'edit'
        this.passwordFrom = {
          ...row
        }
        this.dialogVisible = true
      },
      // 重置表单
      resetForm() {
        if (this.$refs.passwordFrom) {
          this.$refs.passwordFrom.resetFields()
        }
        this.passwordFrom = {
          id: null,
          name: '',
          username: '',
          password: '',
          url: '',
          image: '',
          key: '',
          description: '',
        }
      },
      submitForm(){
        this.$refs.trafficForm.validate((valid) => {
          if(valid){
            this.loading = true
            const apiUrl = this.dialogType === 'add'
                ? '/admin/data/addPassword'
                : '/admin/data/editPassword'
            this.axios.post(apiUrl,this.passwordFrom,{
              token : true
            }).then(res => {
              const {status,data} = res
              if(status === 200 && data && data.data){
                this.$message.success(data.msg)
              }else {
                this.$message.error(data.msg)
              }
            }).catch(error => {
              this.$message.error(error)
            }).finally(() => {
              this.fileList = []
              this.loading = false
              this.dialogVisible = false
              if(this.activeMenu !== 'workPlace'){
                window.location.reload()
              }else {
                this.getUserPasswordList()
              }
            })
          }
        })
      },
      // 处理删除资源
      handleDelete(row) {
        this.$confirm(this.$t('确认删除这条密码项吗？'), this.$t('system.prompt'), {
          confirmButtonText: this.$t('system.confirm'),
          cancelButtonText: this.$t('system.cancel'),
          type: 'warning'
        }).then(() => {
          // 构建删除请求数据，包含需要删除的文件URL
          const deleteData = {
            id: row.id
          };

          // 如果有图片文件，添加到删除数据中
          if (row.image) {
            deleteData.image_url = row.image;
          }

          // 如果有密钥文件，添加到删除数据中
          if (row.key) {
            deleteData.key_url = row.key;
          }
          this.axios.post('/admin/data/deletePassword',deleteData, {
            token: true
          }).then(res => {
            if (res.status === 200 && res.data && res.data.data) {
              this.$message.success(res.data.msg || this.$t('resource.deleteSuccess'))
              this.getUserPasswordList()
            } else {
              this.$message.error(res.data.msg || this.$t('resource.deleteError'))
            }
          }).catch(error => {
            console.error('删除失败:', error)
            this.$message.error(error)
          })
        }).catch(() => {
          this.$message.info(this.$t('trafficList.cancelDelete'))
        })
      },
      handleAdd() {
        this.dialogType = 'add'
        this.resetForm()
        this.dialogVisible = true
      },
      //处理每页条数变化
      handleSizeChange(val){
        this.pagination.pageSize = val
        this.pagination.currentPage = 1
        this.getUserPasswordList()
      },
      //处理页码变化
      handleCurrentChange(val){
        this.pagination.currentPage = val
        this.getUserPasswordList()
      },
      searchEvent() {
        this.pagination.currentPage = 1  // 搜索时重置到第一页
        if(this.group_id){
          this.getGroupPassword()
        }else {
          this.getUserPasswordList()
        }
        //this.getUserPasswordList()
      },
      // 重置搜索条件
      clearSearch() {
        this.searchFrom = {
          name : ''
        }
        this.group_id = ''
        this.searchEvent()  // 重置后重新加载数据
      },
      handleMenuSelect(index){
        console.log(index)
        this.activeMenu = index
        this.pagination.currentPage = 1
        if(index === "workPlace"){
          this.getUserPasswordList()
        }else {
          this.group_id = index
          this.getGroupPassword()
        }

      },
      async handleUpload(file) {
        try {
          const formData = new FormData();
          formData.append('file', file.file);

          const res = await this.axios.post('/admin/data/uploadImage', formData, {
            token: true,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          if (res.status === 200 && res.data && res.data.data) {
            this.passwordFrom.image = res.data.data.list.url; // 使用解密后的URL
            this.imageFileList = [{
              name: file.file.name,
              url: res.data.data.list.url,
              response: res.data
            }];
          } else {
            this.$message.error(res.data.msg || '上传失败');
          }
        } catch (error) {
          this.$message.error(error.message || '上传失败');
        }
      },
      async handleKeyUpload(file) {
        try {
          const formData = new FormData();
          formData.append('file', file.file);

          const res = await this.axios.post('/admin/data/uploadKey', formData, {
            token: true,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          console.log('handleKey')
          console.log(res)
          if (res.status === 200 && res.data && res.data.data) {
            this.passwordFrom.key = res.data.data.list.url; // 使用解密后的URL
            this.keyFileList = [{
              name: file.file.name,
              url: res.data.data.list.url,
              response: res.data
            }];
          } else {
            this.$message.error(res.data.msg || '上传失败');
          }
        } catch (error) {
          this.$message.error(error.message || '上传失败');
        }
      },
      // 限制只能上传一张图片
      handleExceed() {
        this.$message.warning('只能上传一张图片，请先删除当前图片');
      },
      closeDialog(){
        this.dialogVisible = false
        this.fileList = []
      },
      closeImageDialog() {
        this.imageUrl = ''

      },
      showImage(image){
        this.imageUrl = image
        this.dialogImageVisible = true
      },
      // 重置分享表单
      resetShareForm() {
        this.shareForm = {
          targetType: 'user',
          userTargets: [],
          groupTargets: [],
          permission: 'read',
          expiry: null
        };
        this.userOptions = [];
        this.groupOptions = [];
      },
      // 切换目标类型时清空已选
      handleTargetTypeChange() {
        this.shareForm.userTargets = [];
        this.shareForm.groupTargets = [];
        if (this.shareForm.targetType === 'user') {
          this.searchUsers('');
        } else {
          this.getUserGroup();
        }
      },
      // 搜索用户
      searchUsers(query) {
        this.loading = true;
        this.axios.post('/admin/data/getUser', {
          search : query
        }, {
          token: true
        }).then(res => {
          if (res.status === 200 && res.data && res.data.code === 1) {
            this.userOptions = res.data.data.list;
          }
        }).finally(() => {
          this.loading = false;
        });
      },
      // 确认分享
      confirmShare() {
        const isUserMode = this.shareForm.targetType === 'user';
        const targets = isUserMode
            ? this.shareForm.userTargets
            : this.shareForm.groupTargets;

        if (!targets.length) {
          this.$message.warning(`请选择至少一个${isUserMode ? '用户' : '组'}`);
          return;
        }

        const params = {
          password_id: this.currentSharingItem,
          target_type: this.shareForm.targetType,
          targets: targets,
          access: this.shareForm.permission,

        };

        this.axios.post('/admin/data/sharePassword', params, {
          token: true
        }).then(res => {
          if (res.status === 200 && res.data && res.data.code === 1) {
            this.$message.success('分享成功');
            this.dialogShareVisible = false;
          }else {
            this.$message.error(res.data.msg);
          }
        });
      },
      setCurrentSharingItem(row){
        this.currentSharingItemName = row.name
        this.currentSharingItem = row.id
        this.dialogShareVisible = true
        this.searchUsers()
        this.fetchSharedList();
      },
      // 获取已分享列表
      fetchSharedList() {
        if (!this.currentSharingItem) return;

        this.loading = true;
        const targetType = this.activeShareTab; // 'user' 或 'group'

        this.axios.post('/admin/data/getSharedList', {
          password_id: this.currentSharingItem,
          target_type: targetType
        }, {
          token: true
        }).then(res => {
          console.log('fetchSharedList')
          console.log(res.data)
          if (res.status === 200 && res.data && res.data.data) {
            if (targetType === 'user') {
              this.sharedUsers = res.data.data.list;
            } else {
              this.sharedGroups = res.data.data.list;
            }
          }
        }).finally(() => {
          this.loading = false;
        });
      },
      // 格式化权限显示
      formatPermission(permission) {
        const map = {
          'read': '只读',
          'write': '读写',
          'admin': '管理'
        };
        return map[permission] || permission;
      },
      // 撤销分享
      revokeShare(targetType, id, row) {
        console.log('revokeShare')
        console.log(id)
        this.$confirm(`确认要撤销此${targetType === 'user' ? '用户' : '组'}的分享权限吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.post('/admin/data/revokeShare', {
            password_id: this.currentSharingItem,
            target_type: targetType,
            target_id: id,
            access_level: row.access_level
          }, {
            token: true
          }).then(res => {
            console.log('revokeShare')
            console.log(res.data)
            if (res.status === 200 && res.data.code === 1) {
              this.$message.success('撤销成功');
              this.fetchSharedList(); // 刷新列表
            }
          });
        }).catch(() => {
          this.$message.info('已取消操作');
        });
      },
      // 下载密钥文件
      downloadKey(fileUrl) {
        if (!fileUrl) {
          this.$message.warning('没有可下载的密钥文件');
          return;
        }

        // 创建一个隐藏的a标签用于下载
        const link = document.createElement('a');
        link.href = fileUrl;

        // 从URL中提取文件名，如果没有则使用默认名
        const fileName = fileUrl.split('/').pop() || 'download.key';
        link.download = fileName;

        // 触发点击事件
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);

        this.$message.success('开始下载密钥文件');
      },
      // 处理标签页点击
      handleTabClick(tab) {
        const routeMap = {
          password: '/password/password',
          group: '/password/group',
        }

        if (routeMap[tab.name] && this.$route.path !== routeMap[tab.name]) {
          this.$router.push(routeMap[tab.name])
        }
      },
      handleGroupChange(selectedId) {
        if (selectedId) {
          // 选中了某个选项
          console.log('选中了组:', selectedId);

          this.group_id = selectedId
          this.getGroupPassword()
        }
      },
      // 专门处理清除操作
      handleGroupClear() {
        console.log('清除了选择');
        this.group_id = ''
        this.getUserPasswordList()
      },
      // 删除密钥文件
      handleKeyRemove(file, fileList) {
        this.passwordFrom.key = ''
        if (file.response && file.response.data && file.response.data.list && file.response.data.list.url) {
          this.deleteServerFile(file.response.data.list.url, 'key');
        } else if (file.url) {
          this.deleteServerFile(file.url, 'key');
        }
        this.keyFileList = fileList;
      },

// 删除图片文件
      handleImageRemove(file, fileList) {
        this.passwordFrom.image = ''
        console.log('handleImageRemove', file)
        if (file.response && file.response.data && file.response.data.list && file.response.data.list.url) {
          this.deleteServerFile(file.response.data.list.url, 'image');
        } else if (file.url) {
          this.deleteServerFile(file.url, 'image');
        }
        this.imageFileList = fileList;
      },

// 调用API删除服务器上的文件
      deleteServerFile(fileUrl, type) {
        this.axios.post('/admin/data/deleteFile', {
          file_url: fileUrl
        }, {
          token: true
        }).then(res => {
          if (res.status === 200) {
            this.$message.success('文件删除成功');
            // 根据类型清除对应的表单字段
            if (type === 'key') {
              this.passwordFrom.key = '';
            } else if (type === 'image') {
              this.passwordFrom.image = '';
            }
          } else {
            this.$message.error(res.data.msg || '文件删除失败');
          }
        }).catch(error => {
          this.$message.error(error.message || '文件删除失败');
        });
      },

    }
  }
</script>
<style scoped>
.action-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.delete-btn {
  color: #F56C6C;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>